import { useLocale } from "../../hooks/useLocale";
import { TFeaturedComponent } from "src/Featuresmap";
import { TFormType } from "./BaseForm";
import { FormParser } from "../FormParser";
import { GD } from "src/GD";
import { useEffect, useState } from "react";
import { Box } from "@ui/box/Box";
import { TButtonVariant } from "@ui/button/Button";
import { RecursiveCSS } from "@ui/theme/GlobalTheme";

type TFeesProps = {
	target_id: any;
	target_type: TFormType;
	parent_target_id?: any;
	onComplete?: () => void;
	buttons?: {
		title: string;
		onClick?: (data?: any) => void;
		sx?: RecursiveCSS;
		variant?: TButtonVariant;
	}[];
};
export const Fees: TFeaturedComponent<TFeesProps> = ({ target_id, target_type, parent_target_id, onComplete, buttons }) => {
	useLocale();
	// return <BaseForm target_id={target_id} target_type={target_type} type="fees" />;

	const [ready, setReady] = useState<boolean>();
	const [parentData, setParentData] = useState<IAPIResponse<any>>();

	useEffect(() => {
		const loadData = async (type: "channel") => {
			const res = await GD.REQ_API.request({
				method: "settings/get",
				data: {
					target_id: parent_target_id,
					target_type: type,
					type: "fees",
				},
			});
			return res;
		};

		const processParentData = async (type: "channel") => {
			//const channels = [];

			const parentData = await loadData(type);
			setParentData(parentData);
			setReady(true);
		};
		if (target_type === "merchant_terminal") {
			processParentData("channel");
		} else {
			setReady(true);
		}
	}, [target_type]);

	const injectParentData = (data: IAPIResponse<any>) => {
		const dig = (obj: any, target: any) => {
			if (!obj || typeof obj !== "object") {
				return undefined;
			}
			return target in obj
				? obj[target]
				: Object.values(obj).reduce((acc: any, val: any): any => {
						if (acc !== undefined) return acc;
						if (typeof val === "object") return dig(val, target);
				  }, undefined);
		};

		const keys = Object.keys(data.data.data.rates_and_fees).filter(k => k.indexOf("$__") === -1);

		function read(expression: string, ref: number) {
			const finalExpression: string = expression.replace("$ref", ref.toString());
			const uniqueVariables = ["$val"];
			const args = uniqueVariables.concat("return " + finalExpression);

			return new Function(...args);
		}

		for (let index = 0; index < keys.length; index++) {
			const key = keys[index];
			const findParent = dig(parentData, key);
			if (findParent !== undefined) {
				data.data.data.rates_and_fees["$__" + key + "_refvalue"] = findParent;

				//const expression: string = "$val >= $ref && $val < 10 && alert('123')";
				const expression: string = "$val >= $ref && $val < 10";
				const condition = read(expression, findParent);

				data.data.data.rates_and_fees["$__" + key + "_validator"] = condition;
			}
		}
	};

	//!TODO: set id ti ref;
	return (
		<Box id="formTest">
			{ready && (
				<FormParser
					key="credentials"
					onSubmit={(data: any) =>
						GD.REQ_API.request({
							method: "settings/set",
							data: data,
						})
					}
					onRequest={async () => {
						const response = await GD.REQ_API.request({
							method: "settings/get",
							data: { target_id, target_type, type: "fees" },
						});
						if (!response.error) injectParentData(response);
						return response;
					}}
					buttons={buttons}
					onComplete={() => {
						onComplete && onComplete();
					}}
				/>
			)}
		</Box>
	);
};

Fees.feature = "fees";
